import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar';
import Home from './Components/Home'
import Shop from './Components/Shop';
import Cart from './Components/Cart'
import Wishlist from './Components/Wishlist'
import ProductDetails from './Components/ProductDetails';
import Checkout from './Components/CheckOut';
import Login from './Components/Login';
import Address from './Components/Address';
import PlaceOrder from './Components/PlaceOrder';
import Footer from './Components/Footer';
import ContactUs from './Components/ContactUs';
import Payment from './Components/Payment';
import Profile from './Components/Profile';
import Order from './Components/Order';
import SavedAddress from './Components/SavedAddress';
import Myaccount from './Components/Myaccount';
import ForgotPassword from './Components/ForgotPassword';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path='/Shop' element={<Shop/>}/>
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/Footer" element={<Footer/>}/>
          <Route path="/contact" element={<ContactUs />} />
          <Route path='/payment' element={<Payment/>}/>
          <Route path='/cart' element={<Cart/>}/>
          <Route path='/wishlist' element={<Wishlist/>}/>
          <Route path='/profile' element={<Profile/>}/>
          <Route path='/order' element={<Order/>}/>
          <Route path='/saved-address' element={<SavedAddress/>}/>
          <Route path='/Myaccount' element={<Myaccount/>}/>
          <Route path='Forgot-password' element={<ForgotPassword/>}/>

          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/login" element={<Login />} />
          <Route path="/checkout/address" element={<Address />} />
          <Route path="/checkout/placeorder" element={<PlaceOrder />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
